import app from '../../forum/app';
import PaginatedListState, { Page, PaginatedListParams, PaginatedListRequestParams } from '../../common/states/PaginatedListState';
import Notification from '../../common/models/Notification';
import AllConfirmModal from '../../common/dianliang/AllConfirmModal';
import AlertUtil from '../../forum/dianLiang/alertUtil';

export interface DiscussionListParams extends PaginatedListParams {
  sort?: string;
}
export default class NotificationListState<P extends DiscussionListParams = DiscussionListParams> extends PaginatedListState<Notification> {
  constructor(params: P) {
    super(params, 1, 20);
  }
  
  get type(): string {
    return 'notifications';
  }

  /**
   * Load the next page of notification results.
   */
  load(): Promise<void> {
    // if (app.session.user?.newNotificationCount()) {
    //   this.pages = [];
    //   this.location = { page: 1 };
    // }
    this.pages = [];
    this.location = { page: 1 };

    if (this.pages.length > 0) {
      return Promise.resolve();
    }

    app.session.user?.pushAttributes({ newNotificationCount: 0 });

    return super.loadNext();
  }

  clear(): void {
    super.clear();
    
    this.params.filter = {};
  }

  requestParams(): PaginatedListRequestParams {
    const params = {
      filter: this.params.filter || {},
    };
    
    if (this.params.q) {
      params.filter.q = this.params.q;
    }

    return params;
  }

  /**
   * Mark all of the notifications as read.
   */
  markAllAsRead(type : number) {
    if (this.pages.length === 0) return;
    
    app.modal.show(AllConfirmModal, {
      title: app.translator.trans('dl-response.forum.sure_read_modal.warn_title'),
      text: app.translator.trans('dl-response.forum.sure_read_modal.please_sure_read'),
      promise: true,
      onconfirm: (resolve, reject) => {
        app.session.user?.pushAttributes({ unreadNotificationCount: 0 });

        this.pages.forEach((page) => {
          page.items.forEach((notification) => notification.pushAttributes({ isRead: true }));
        });

        return app.request({
          url: app.forum.attribute('apiUrl') + '/notifications/read',
          method: 'POST',
          body: {type:type ? type : 0},
        }).then(result => {
          m.redraw();
          AlertUtil.onSuccess(app, app.translator.trans('dl_discussion_controller.forum.pushFrontModal.admin_submit_success'));
        });
      },
    }, true)

    
  }

  /**
   * Delete all of the notifications for this user.
   */
  deleteAll(type : number) {
    if (this.pages.length === 0) return;

    app.modal.show(AllConfirmModal, {
      title: app.translator.trans('dl-response.forum.sure_read_modal.warn_title'),
      text: app.translator.trans('dl-response.forum.sure_read_modal.please_sure_delete'),
      promise: true,
      onconfirm: (resolve, reject) => {
        app.session.user?.pushAttributes({ unreadNotificationCount: 0 });

        this.pages = [];

        return app.request({
          url: app.forum.attribute('apiUrl') + '/notifications',
          method: 'DELETE',
          body: {type:type ? type : 0},
        }).then(result => {
            m.redraw();
            AlertUtil.onSuccess(app, app.translator.trans('dl_discussion_controller.forum.pushFrontModal.admin_submit_success'));
          });
        },
      }, true)

    
  }
}
